import {
  RENTERS_DOWNLOADED,
  RENTERS_FAILED,
  RENTERS_PENDING,
  RENTERS_RESET,
  RENTER_DOWNLOADED,
  RENTER_SENDING,
  RENTER_REMOVED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let renters = [];
  let renterIndex = -1;
  switch (action.type) {
    case RENTERS_RESET:
      return INITIAL_STATE;
    case RENTERS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case RENTERS_DOWNLOADED:
      return {
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case RENTER_SENDING:
      return {
        ...state,
        sending: true,
      };
    case RENTER_DOWNLOADED:
      if (state.content) {
        renters = state.content.slice();
        renterIndex = renters.findIndex((renter) => renter.id === action.payload.id);
      }
      if (renterIndex === -1) {
        renters.push(action.payload);
      } else {
        renters[renterIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: renters,
      };
    case RENTER_REMOVED:
      renters = state.content.slice();
      renterIndex = renters.findIndex((renter) => renter.id === action.payload);
      if (renterIndex !== -1) {
        renters[renterIndex].remove = true;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: renters,
      };
    case RENTERS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/renters/reducers.js